<template>
    <div>
        <div class="bg" :style="{
            'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
            'backgroundColor': '#f5f5f5' // 添加备用背景色
        }">
            <div class="top_box">
                <img :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }" class="logo">
                <div class="right_top_box">
                    <div class="right_top_txt">{{ $t('PoweredbyMVGX') }}</div>
                    <!-- <div class="right_top_txt_shu">|</div>
                    <Kefu :sn='sn'></Kefu> -->
                </div>
            </div>

            <div class="password_box">
                <div class="ps_title">{{ $t('Pleasesetapasscodeforfutureaccess') }}</div>
                <el-row class="ps_ipt" type="flex" :gutter="10" justify="space-around">
                    <el-col v-for="(item, index) in arr" :key="index">
                        <el-input v-model="item.num" ref="numInput" inputmode="numeric" oninput="value=value.replace(/[^\d]/g,'')"
                            :focus="currIndex == index" type="password" @input="nextFocus(index)"
                            maxlength="1"></el-input>
                    </el-col>
                </el-row>
                <div class="pas_txt">{{ $t('Passcodeis6digits') }}</div>
            </div>


            <div class="po_box">
                <el-button class="btn" @click="gotoPath()">{{ $t('Submit') }}</el-button>
            </div>

        </div>
        <el-dialog title="" :visible.sync="centerDialogVisible" :close-on-click-modal="false" width="95%"
            :show-close="false" center>
            <div>{{ message }}</div>
            <span slot="footer" class="dialog-footer">
                <div class="btn_cancel" @click="centerDialogVisible = false">{{ $t('Close') }}</div>
            </span>
        </el-dialog>

        <el-dialog title="" :visible.sync="saveDialogVisible" :close-on-click-modal="false" width="95%"
            :show-close="true" :destroy-on-close="true" @close="gotopath1" class="code" center>
            <div class="red">{{ $t('Pleasescreenshot') }}</div>
            <div class="dia_img">
                <img :src="config.logoSmallImg" style="width:70px" class="qrimg">
                <vue-qr :logo-src="imgurl" :size="150" :margin="0" :auto-color="true" :correctLevel="3" :dot-scale="1"
                    :logoMargin="3" :logoScale="0.24" :logoCornerRadius="1" :text="host" ref="qrCode" id="qrmain" />
            </div>
            <div class="txtPla">{{ $t('ThisQRcode') }}</div>
        </el-dialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import cnt from '@/api/cnt'
import Kefu from '@/components/kefu.vue'
import VueQr from 'vue-qr';
export default {
    name: 'password',
    // import引入的组件需要注入到对象中才能使用
    components: { Kefu, VueQr },
    data() {
        // 这里存放数据
        return {
            arr: [
                {
                    num: ''
                },
                {
                    num: ''
                },
                {
                    num: ''
                },
                {
                    num: ''
                },
                {
                    num: ''
                },
                {
                    num: ''
                },
            ],
            currIndex: -1,
            password: '',
            sn: '',
            centerDialogVisible: false,
            saveDialogVisible: false,
            imgurl: require('../assets/img/qr.png'),
            message: '',
            host: '',
            config: '',
        }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.sn = this.$route.query.sn
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
        this.getHost()
        setTimeout(() => {
            this.$refs.numInput[0] && this.$refs.numInput[0].focus();
        }, 0);
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        //   this.getUserEvent(1,1)
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
    // 方法集合
    methods: {
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        // 获取完整域名
        getHost() {
            this.host = window.location.protocol + "//" + window.location.host + '/welcome-home?sn=' + this.sn; // 获取主机名（协议 + 主机 + 端口)

        },
        gotopath1() {
            this.saveDialogVisible = false
            this.$router.push({ path: '/trip', query: { sn: this.sn } })
        },
        nextFocus(index) {
            if (this.arr[index].num) {
                if (index < this.arr.length - 1) {
                    this.currIndex = index + 1
                    this.$refs.numInput[this.currIndex].focus();
                } else {
                    this.currIndex = index
                    this.$refs.numInput[this.currIndex].focus();
                }
            } else {
                this.currIndex = index - 1
                this.$refs.numInput[this.currIndex].focus();
            }
            console.log(this.currIndex, index)
        },
        gotoPath() {
            this.password = ''
            this.message = ''
            for (let i = 0; i < this.arr.length; i++) {
                this.password += this.arr[i].num
            }
            let params = {
                authType: 1,
                username: this.sn,
                password: this.password,
            }
            if (this.password.length < 6) {
                this.centerDialogVisible = true
                this.message = this.$t('Pleaseseta6digitspasscode')
                return
            }
            cnt.changePassword(res => {
                if (res.code == 200) {
                    sessionStorage.setItem('user', JSON.stringify(res.data))
                    this.getUserEvent(2, 2)
                    this.saveDialogVisible = true
                    // this.$router.push({path: '/trip',query: {sn:this.sn}})
                } else {
                    this.centerDialogVisible = true
                    this.message = res.message
                }

            }, params)
        }
    }
}
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.top_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    margin-top: 40px;
}

a {
    color: #ffffff;
    text-decoration: none;
}

.bg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    // background: url('../assets/img/bj.png') no-repeat;
    background-repeat: no-repeat;
    // position: relative;
    background-size: 100% 100%;
}

.po_box {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    // width: 100%;
    padding: 0 20px;
    bottom: 0;
}

::v-deep .password_box {
    margin-top: 64.5px;
    padding: 0 20px;
    text-align: center;

    .ps_title {
        font-size: 24px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #FFFFFF;
    }

    .ps_ipt {
        display: flex;
        margin-top: 38px;

        .el-input__inner {
            height: 60px;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 10px;
            backdrop-filter: blur(2.5px);
            border: 1px solid #ffffff4d;
            color: #FFFFFF;
            font-size: 30px;
            text-align: center;
            padding: 0 10px;
        }
    }

    .pas_txt {
        text-align: left;
        padding: 8px 0 21.5px 0;
        font-size: 12px;
        font-family: Century Gothic;
        color: #FFFFFF;
    }

    .check_box {
        text-align: left;

        .el-checkbox__label {
            font-size: 13px;
            font-family: Century Gothic;
            color: #FFFFFF;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #4D94A0;
            border-color: #4D94A0;
        }

        .el-checkbox__inner:hover {
            border-color: #4D94A0;
        }
    }
}

.right_top_box {
    // position: absolute;
    display: flex;
    align-items: center;

    .right_top_txt {
        font-size: 12px;
        font-family: Century Gothic;
        color: #EDFFFE;
    }

    .right_top_txt_shu {
        margin: 0 12px;
        color: #EDFFFE;
    }

    .bangzhu {
        width: 17px;
        height: 17px;
    }
}

.logo {
    width: auto;
}

.content {
    background-color: rgba(255, 255, 255, 0.13);
    backdrop-filter: blur(5px);
    padding: 49px 0;
    text-align: center;
    color: #fff;
    border-radius: 20px;
}

.error {
    width: 54px;
    height: 54px;
    margin-bottom: 33px;

}

.content_con {
    margin: 0 20px;
    font-size: 15px;
    font-family: Century Gothic;
}

.please {
    margin: 60px 20px 116px;
    font-size: 13px;
    font-family: Century Gothic;
    color: #FFFFFF;
    text-align: center;

}

.please>span {
    font-weight: bold;
}

.btn {
    width: 335.5px;
    height: 45px;
    color: #4D94A0;
    margin-bottom: 21px;
    border-radius: 10px;
    font-size: 15px;
    font-family: Century Gothic;
    box-shadow: 0rem .3125rem .75rem 0rem rgba(0, 98, 76, 0.22);
}

::v-deep .code {
    .el-dialog {
        margin-top: 15vh !important;
    }
}

::v-deep .el-dialog {
    background: #FFFFFF;
    border-radius: 20px;
    margin-top: 30vh !important;

    .el-dialog__title {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #303236;
        line-height: 25px;
    }

    .el-dialog__body {
        font-size: 15px;
        font-family: Century Gothic;
        color: #8F8F8F;
        line-height: 20px;
        text-align: center;
        padding: 1.5625rem .875rem 1.875rem !important;
    }

    .red {
        color: #FA626B;
        font-size: 14px;
    }

    .dia_img {
        width: calc(100% - 60px);
        height: auto;
        margin: 10px 30px;
        position: relative;
        display: flex;
        align-items: center;

        .qrimg {
            position: absolute;
            height: auto;
            text-align: center;
            left: calc((100% - 70px) / 2)
        }

        img {
            width: 100%;
            height: 100%;
        }
    }

    .dialog-footer {
        display: flex;
        justify-content: center;

        .btn_cancel {
            width: 131px;
            height: 45px;
            // box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            border: 1px solid;
            box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
            border-color: linear-gradient(90deg, rgba(107, 179, 201, 1), rgba(90, 198, 153, 1)) 1 1;
            font-size: 15px;
            font-family: Century Gothic;
            color: #4D94A0;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-right: 10px;
        }

        .btn_save {
            width: 131px;
            height: 45px;
            border-radius: 10px;
            border: 1px solid;
            background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            border-color: linear-gradient(90deg, rgba(107, 179, 201, 1), rgba(90, 198, 153, 1)) 1 1;
            box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
            font-size: 15px;
            font-family: Century Gothic;
            color: #FFFFFF;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }

        .btn_confirm {
            width: 131px;
            height: 47px;
            background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            font-size: 15px;
            font-family: Century Gothic;
            color: #FFFFFF;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-left: 10px;
        }
    }
}

.txtPla{
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
}
</style>
